// extracted by mini-css-extract-plugin
export default {"container":"article_container__1YYvt","inner":"article_inner__36E5k","isContainer":"article_isContainer__DuyJV"};